import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
const ParkingPage = lazy(() => import("./parking"));
const AssetEditorPage = lazy(() => import("./pages/AssetEditorPage"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <ParkingPage />,
  },
  {
    path: "/editor",
    element: <AssetEditorPage />,
  },
]);
function App() {
  return (
    <Suspense fallback={""}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
